// use lodash! https://lodash.com/docs/4.17.15
import thing from './components/thing'
import publicationsDateToggle from './components/publicationsDateToggle'

const fndryThemeInitWrapper = () => {
	thing();
	publicationsDateToggle();
};

window.fndryThemeInitWrapper = fndryThemeInitWrapper;

// eslint-disable-next-line no-unused-expressions
document.body
  ? fndryThemeInitWrapper()
  : document.addEventListener("DOMContentLoaded", fndryThemeInitWrapper, false);
